import { Calendar, Plus, ChevronLeft, ChevronRight } from 'lucide-react';

const FG = '#F5F1FA';
const MUTED = '#A99FB8';
const SURFACE2 = '#140C20';
const SURFACE = '#1B1029';
const VIOLET = '#6D28D9';
const VIOLET_LIGHT = '#A855F7';
const CHAMPAGNE = '#E8B96A';
const BORDER = 'rgba(255,255,255,0.08)';

const DAYS_HEADER = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

// Grade mensal junho 2026: começa na terça (idx 2)
// Semana 1: [-, -, 1, 2, 3, 4, 5]
// Semana 2: [6, 7, 8, 9, 10, 11, 12]
// Semana 3: [13, 14, 15, 16, 17, 18, 19]
// Semana 4: [20, 21, 22, 23, 24, 25, 26]
// Semana 5: [27, 28, 29, 30, -, -, -]
const WEEKS: (number | null)[][] = [
  [null, null, 1, 2, 3, 4, 5],
  [6, 7, 8, 9, 10, 11, 12],
  [13, 14, 15, 16, 17, 18, 19],
  [20, 21, 22, 23, 24, 25, 26],
  [27, 28, 29, 30, null, null, null],
];

const EVENTOS: Record<number, { label: string; color: string; bg: string }[]> = {
  15: [{ label: 'Audiência 10h', color: VIOLET_LIGHT, bg: 'rgba(168,85,247,0.18)' }],
  18: [{ label: 'Prazo: contestação', color: CHAMPAGNE, bg: 'rgba(232,185,106,0.15)' }],
  23: [{ label: 'Reunião cliente', color: '#4ADE80', bg: 'rgba(74,222,128,0.13)' }],
};

export function AgendaMockup() {
  return (
    <div
      style={{
        width: '100%',
        borderRadius: 16,
        overflow: 'hidden',
        border: `1px solid ${BORDER}`,
        background: SURFACE2,
        boxShadow:
          '0 0 0 1px rgba(109,40,217,0.15), 0 32px 80px rgba(0,0,0,0.55), 0 8px 24px rgba(109,40,217,0.12)',
        fontFamily: "'Hanken Grotesk', sans-serif",
      }}
    >
      {/* Titlebar */}
      <div
        style={{
          background: 'rgba(20,12,32,0.98)',
          borderBottom: `1px solid rgba(255,255,255,0.07)`,
          padding: '12px 18px',
          display: 'flex',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div style={{ display: 'flex', gap: 7, flexShrink: 0 }}>
          {['#FF5F56', '#FFBD2E', '#27C93F'].map((c) => (
            <span
              key={c}
              style={{
                width: 11,
                height: 11,
                borderRadius: '50%',
                background: c,
                opacity: 0.75,
                display: 'inline-block',
              }}
            />
          ))}
        </div>
        <Calendar size={13} color={VIOLET_LIGHT} strokeWidth={2} />
        <span style={{ fontSize: 12, fontWeight: 600, color: FG }}>Agenda</span>
      </div>

      {/* Toolbar */}
      <div
        className="agenda-toolbar"
        style={{
          background: 'rgba(20,12,32,0.6)',
          borderBottom: `1px solid ${BORDER}`,
          padding: '10px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
        }}
      >
        {/* Navegacao mes */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <button
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'default',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ChevronLeft size={13} color={MUTED} strokeWidth={2} />
          </button>
          <span style={{ fontSize: 12, fontWeight: 700, color: FG, minWidth: 76, textAlign: 'center' }}>
            Junho 2026
          </span>
          <button
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'default',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ChevronRight size={13} color={MUTED} strokeWidth={2} />
          </button>
        </div>

        {/* Toggle visao */}
        <div
          style={{
            display: 'flex',
            gap: 0,
            background: SURFACE,
            border: `1px solid ${BORDER}`,
            borderRadius: 7,
            overflow: 'hidden',
          }}
        >
          {['Mês', 'Semana', 'Dia'].map((v, i) => (
            <span
              key={v}
              style={{
                fontSize: 10,
                fontWeight: i === 0 ? 700 : 400,
                color: i === 0 ? FG : MUTED,
                background: i === 0 ? 'rgba(109,40,217,0.35)' : 'transparent',
                padding: '4px 10px',
                cursor: 'default',
                borderRight: i < 2 ? `1px solid ${BORDER}` : 'none',
              }}
            >
              {v}
            </span>
          ))}
        </div>

        {/* Botao adicionar */}
        <button
          style={{
            marginLeft: 'auto',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 10,
            fontWeight: 700,
            color: FG,
            background: `linear-gradient(135deg, ${VIOLET} 0%, ${VIOLET_LIGHT} 100%)`,
            border: 'none',
            borderRadius: 7,
            padding: '5px 11px',
            cursor: 'default',
            fontFamily: 'inherit',
          }}
        >
          <Plus size={11} strokeWidth={2.5} />
          Adicionar
        </button>
      </div>

      {/* Grade do calendario */}
      <style>{`
        @media (max-width: 600px) {
          .agenda-cal-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
          .agenda-cal-inner { min-width: 320px; }
          .agenda-toolbar { flex-wrap: wrap; gap: 8px !important; }
        }
      `}</style>
      <div className="agenda-cal-wrap" style={{ padding: '12px 14px 16px' }}>
        <div className="agenda-cal-inner">
        {/* Cabecalho Dia da semana */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: 2,
            marginBottom: 4,
          }}
        >
          {DAYS_HEADER.map((d) => (
            <div
              key={d}
              style={{
                textAlign: 'center',
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase' as const,
                color: MUTED,
                padding: '4px 0',
              }}
            >
              {d}
            </div>
          ))}
        </div>

        {/* Semanas */}
        {WEEKS.map((week, wi) => (
          <div
            key={wi}
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
              gap: 2,
              marginBottom: 2,
            }}
          >
            {week.map((day, di) => {
              const isToday = day === 15;
              const eventos = day ? (EVENTOS[day] ?? []) : [];

              return (
                <div
                  key={di}
                  style={{
                    minHeight: 52,
                    borderRadius: 7,
                    background: day
                      ? isToday
                        ? 'rgba(109,40,217,0.12)'
                        : 'rgba(27,16,41,0.6)'
                      : 'transparent',
                    border: day ? `1px solid ${isToday ? 'rgba(168,85,247,0.35)' : BORDER}` : 'none',
                    padding: '5px 5px 4px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                  }}
                >
                  {day && (
                    <>
                      {/* Numero do dia */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          alignSelf: 'flex-start',
                          width: 20,
                          height: 20,
                          borderRadius: '50%',
                          background: isToday ? VIOLET : 'transparent',
                          boxShadow: isToday ? `0 0 10px ${VIOLET}80` : 'none',
                          fontSize: 10,
                          fontWeight: isToday ? 700 : 400,
                          color: isToday ? FG : MUTED,
                          lineHeight: 1,
                        }}
                      >
                        {day}
                      </div>

                      {/* Chips de evento */}
                      {eventos.map((ev, ei) => (
                        <div
                          key={ei}
                          style={{
                            fontSize: 8,
                            fontWeight: 600,
                            color: ev.color,
                            background: ev.bg,
                            borderRadius: 3,
                            padding: '2px 4px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {ev.label}
                        </div>
                      ))}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        ))}
        </div>{/* /agenda-cal-inner */}
      </div>
    </div>
  );
}
